import axios from "axios";
import { useEffect, useState } from "react";

import { MagnoliaImage } from "@/app/shared-components/image-wrapper/image";
import {
  MAGNOLIA_NEXT_API_URL,
  PRODUCT_DOMAIN,
  TRUSTPILOT_CONTENT_URL,
} from "@/constants";

export type TruspilotBannerData = {
  trustpilotText: string;
  trustpilotImage: MagnoliaImage | null | undefined;
  trustpilotUrl: string;
};

type ProductDomainKey = "STS" | "AVN" | "EXP" | "IRE" | "ESP";

export function useTrustpilotBannerData() {
  const [data, setData] = useState<TruspilotBannerData>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const productDomain = {
    STS: "staysure",
    AVN: "avanti",
    EXP: "expat",
    IRE: "ireland",
    ESP: "spain",
  };

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchDashboard() {
      try {
        const result = await axios.get(
          `${MAGNOLIA_NEXT_API_URL}/${TRUSTPILOT_CONTENT_URL}/${
            productDomain[PRODUCT_DOMAIN as ProductDomainKey]
          }`,
          {
            signal: abortController.signal,
          }
        );

        if (result && result.data) {
          const trustpilotData = result.data.data;
          setData({
            trustpilotText: trustpilotData?.trustpilotText,
            trustpilotImage: trustpilotData?.trustpilotImage,
            trustpilotUrl: trustpilotData?.trustpilotUrl,
          });
        }
      } catch (err) {
        if (!abortController.signal.aborted) {
          setError(
            err instanceof Error
              ? err
              : new Error("Failed to fetch trustpilot header data")
          );
        }
      } finally {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      }
    }

    fetchDashboard();

    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, isLoading, error };
}
